export class MaxAggregator {
    constructor(field) {
        this._max = null;
        this._type = 'max';
        this._field = field;
    }
    get field() {
        return this._field;
    }
    get type() {
        return this._type;
    }
    init() {
        this._max = null;
    }
    accumulate(item) {
        const val = (item && item.hasOwnProperty(this._field)) ? item[this._field] : null;
        if (val !== null && val !== '' && !isNaN(val)) {
            if (this._max === null || val > this._max) {
                this._max = parseFloat(val);
            }
        }
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals[this._type] === undefined) {
            groupTotals[this._type] = {};
        }
        groupTotals[this._type][this._field] = this._max;
    }
}
//# sourceMappingURL=maxAggregator.js.map